/**
 * @author Blueprint Frontend Team
 */
import "../scss/index.scss";
import { header } from './layouts';
import { slider, tabs, accordion, pageAnim } from './components';

import { loadPage } from './utils';
import { applyForm } from './modules';

(function () {
  loadPage.init();

  // Layouts
  header.init();


  // Partials Modules
  slider.init();
  tabs.init();
  accordion.init();
  pageAnim.init();

  applyForm .init();


  // Page Modules
}());
